export default "__VITE_PUBLIC_ASSET__d095b7a5__"